import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponse } from 'services/api/types';
import type {
  UserProfile,
  UserProfileBody,
  UserProfileMunicipality,
  UserProfileOrganization,
  UserProfileMunicipalityBody,
  UsersRequest,
  GetOrganizationParams,
  CurrentProfile,
} from './types';

/**
 * Legacy: needs to remove
 */
export const getCurrentUser = (): Promise<UserProfile> => {
  return appApi
    .get('/users_profile/current_profile/')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Ошибка получения профиля' });
      throw error;
    });
};

export const getCurrentProfile = (): Promise<CurrentProfile> => {
  return appApi
    .get('/profile/current')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Ошибка при получения текущего профиля' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const createUserProfile = (body: UserProfileBody): Promise<UserProfile> => {
  return appApi
    .post('/users_profile/', body)
    .then((res) => res.data)
    .catch((error) => {
      switch (error.response.status) {
        case 409:
          notification.error({ message: 'Пользователь с указанным е-мэйлом уже существует' });
          break;
        default:
          notification.error({ message: 'Неизвестная ошибка при регистрации' });
      }
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const getUserProfile = (userId: number): Promise<UserProfile> => {
  return appApi
    .get(`/users_profile/${userId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Ошибка получения профиля' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const updateUserProfile = (userId: number, body: UserProfileBody): Promise<UserProfile> => {
  return appApi
    .put(`/users_profile/${userId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Ошибка обновления профиля' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const removeUserProfile = (userId: number): Promise<number> => {
  return appApi
    .delete(`/users_profile/${userId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить пользователя' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const getUsers = (payload: UsersRequest): Promise<ListResponse<UserProfile>> => {
  return appApi
    .get('/users_profile/', { params: payload })
    .then(({ data, headers }) => {
      return {
        data,
        total: Number(headers['totalelements']) || 0,
      };
    })
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить пользователей' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const passwordRecovery = (email: string, showNotification = true): Promise<void> => {
  return appApi
    .post(`/users_profile/password_recovery/${encodeURIComponent(email)}`)
    .then(() => {
      showNotification && notification.success({ message: 'На указанную почту отправлено письмо' });
    })
    .catch((error) => {
      showNotification &&
        notification.error({ message: 'Не удалось выполнить восстановление пароля' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const getOrganizationsAll = (
  params: GetOrganizationParams,
): Promise<ListResponse<UserProfileOrganization>> => {
  return appApi
    .get('/organization/', {
      params,
    })
    .then(({ data, headers }) => {
      return {
        data,
        total: Number(headers['totalelements']) || 0,
      };
    })
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить организации' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const getMunicipalitiesOld = (regionId: string): Promise<UserProfileMunicipality[]> => {
  return appApi
    .get(`/municipality/?regionId=${regionId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить районы' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const removeMunicipalityOld = (municipalityId: number): Promise<number> => {
  return appApi
    .delete(`/municipality/${municipalityId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить район' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const createMunicipalityOld = (
  body: UserProfileMunicipalityBody,
): Promise<UserProfileMunicipality> => {
  return appApi
    .post('/municipality/', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать район' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const updateMunicipalityOld = (
  body: UserProfileMunicipality,
): Promise<UserProfileMunicipality> => {
  return appApi
    .put(`/municipality/${body.id}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить район' });
      throw error;
    });
};

/**
 * Legacy: needs to remove
 */
export const changePassword = (password: string): Promise<void> => {
  return appApi
    .put(`/users_profile/change_password/${password}`)
    .then(() => {
      notification.success({ message: 'Пароль успешно изменен' });
    })
    .catch((error) => {
      notification.error({ message: 'Не удалось изменить пароль' });
      throw error;
    });
};
